<script>
    export let type = 'info'
    export let message = ''
</script>

<div class="toast toast-{type}" role="alert">
    <button class="btn btn-clear float-right" on:click aria-hidden="true"></button>
    <slot>{message}</slot>
</div>
